import React from 'react';
import './partners.scss';
import { Container, Typography } from '@material-ui/core';
import PartnersCarousel from './../partners_carousel/partners_carousel';
const Partners = () => {
  return (
    <div className="App_partners" id="Partners">
      <Container maxWidth="md">
        <Typography variant="h2">Partners</Typography>
      </Container>
      <PartnersCarousel />
    </div>
  );
};

export default Partners;
